import { render } from "./OidcCallbackMicrosoft.vue?vue&type=template&id=d482dcf4"
import script from "./OidcCallbackMicrosoft.vue?vue&type=script&lang=js"
export * from "./OidcCallbackMicrosoft.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/OidcCallbackMicrosoft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d482dcf4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d482dcf4', __exports__)) {
    api.reload('d482dcf4', __exports__)
  }
  
  module.hot.accept("./OidcCallbackMicrosoft.vue?vue&type=template&id=d482dcf4", () => {
    api.rerender('d482dcf4', render)
  })

}


export default __exports__